export default `
  fragment PromptBookSummaryFragment on prompt_books_summary {
    promptId:prompt_id
    bookId:book_id
    answersCount:answers_count
  }
`;
